/*
 * Created on Wed Oct 11 2023 4:56:55 PM
 *
 * ***************************************************************************************
 * Copyright (c) AVPS Technologies Inc 2023 
 *
 * All Rights Reserved
 * Unpublished rights are reserved under the copyright laws of the United States.
 * The software contained in this media is proprietary to and embodies confidential
 * the technology of AVPS Technologies Inc. Possession, use, duplication or
 * dissemination of the software and media is authorized only pursuant to a valid
 * written license from AVPS Technologies Inc.
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * RESTRICTED RIGHTS LEGEND Use, duplication, or disclosure by the U.S. Government
 * is subject to restrictions as set forth in Subparagraph (c) (1) (ii) of DFARS
 * 252.227-7013 or in FAR 52.227-19, as applicable.
 ****************************************************************************************
 */

import { motion } from 'framer-motion';
import { Repeat, ArrowRight } from 'lucide-react';

const RecurrenceButton = ({ hasRecurrence, displayText, onClick, disabled }) => {
  return (
    <motion.button
      whileHover={{ scale: 1.02 }}
      whileTap={{ scale: 0.98 }}
      onClick={onClick}
      disabled={disabled}
      className={`w-full flex items-center justify-between p-5 rounded-xl border-2 transition-all duration-200 disabled:opacity-50 disabled:cursor-not-allowed ${hasRecurrence
          ? 'border-emerald-200 bg-emerald-50 hover:bg-emerald-100'
          : 'border-slate-200 bg-slate-50 hover:bg-slate-100 hover:border-slate-300'
        }`}
    >
      <div className="flex items-center">
        <Repeat className={`w-5 h-5 mr-3 ${hasRecurrence ? 'text-emerald-600' : 'text-slate-600'}`} />
        <div className="text-left">
          <div className={`font-semibold text-sm ${hasRecurrence ? 'text-emerald-700' : 'text-slate-700'}`}>
            {hasRecurrence ? 'Recurrence Set' : 'Add Recurrence'}
          </div>
          {hasRecurrence && (
            <div className="text-xs text-emerald-600 mt-0.5">
              {displayText}
            </div>
          )}
        </div>
      </div>
      <ArrowRight className={`w-4 h-4 ${hasRecurrence ? 'text-emerald-600' : 'text-slate-400'}`} />
    </motion.button>
  );
};

export default RecurrenceButton;